import { useCallback, useState } from 'react'
import { useAppDispatch } from '@sales-center/common'
import { getServiceProductList } from '../api'

type State = {
  loading: boolean
}

export function useGetBranchServiceProducts() {
  const dispatch = useAppDispatch()

  const [state, setState] = useState<State>(() => ({ loading: false }))

  const getServices = useCallback(
    async (branchId: string) => {
      setState({ loading: true })

      try {
        const result = await dispatch(getServiceProductList(branchId))
        if (getServiceProductList.fulfilled.match(result)) {
          setState({
            loading: false,
          })
        }
      } catch {
        setState({ loading: false })
      }
    },
    [dispatch],
  )

  return {
    ...state,
    getServices,
  }
}
